import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Tooltip,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  format,
  // formatISO,
  getDaysInMonth,
  getMonth,
  getYear,
} from "date-fns";
import {
  DATE_TIME_FORMAT_1,
  INVALID_URL,
  ItemInspectionEnum,
  ItemResultType,
  TYPE_FILE_UPLOAD,
  UploadFileType,
} from "@app/constants";
import {
  IconInvalidUrl,
  IconLocationMachine,
  IconReportCircle,
  IconTick,
  IconUser,
  IconDeleteRow,
  IconInputError,
  IconDeleteGray,
  IconEditSquare,
} from "@app/components/icons";
import { IconDeleteRed } from "@app/components/icons/IconDeleteRed/IconDeleteRed";
import { useTranslation } from "react-i18next";
import { DataDialog, DataTooltip } from "@app/components/atoms";
import {
  formatNumberWithCommas,
  formatTime,
  iOSversion,
  isMobile,
  resetScroll,
  REGEX,
  handleUploadStore,
} from "@app/helpers";
import {
  Avatar,
  Box,
  TextField,
  // DialogActions,
  // DialogContent,
} from "@mui/material";
import { Inspection } from "@app/types";
import { useParams } from "react-router-dom";
import {
  getMachineReportDetail,
  updateMachineReportStatus,
  deleteInspection,
  apiGetInspectionDetail,
  apiGetInspectionItemDetail,
  apiUpdateInspectionItem,
  // apiUpdateInspectionAt,
  // apiGetInspectionAt,
  getUser,
} from "@app/api";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsUpdatedMachineReportResponses,
  store,
  setShowAlert,
  RootState,
} from "@app/store";
import { useOutletContext } from "react-router-dom";
import { useAppContext } from "@app/AppContext";

import { PictureAsPdfOutlined } from "@mui/icons-material";
// import { DatePickerInput } from "@app/components/atoms";
import { IconWarningFormEdit } from "@app/components/icons";

import { INCIDENT_REPORTS } from "@app/constants";

import { Button } from "@mui/material";

import {
  IconMaintenaceNew,
  IconNotApplicableDashInspection,
} from "@app/components/icons/IconMaintenace/IconMaintenanceNew";
import { IconSelectedNew } from "@app/components/icons/IconSelected/IconSelectedNew";

import RecordRTC from "recordrtc";

import StopIcon from "@mui/icons-material/Stop";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";

import "@app/pages/Features/MachineDetail/Components/InspectionHistory/recording.css";
import { IconMessageNew } from "@app/components/icons/IconMessage/IconMessage";
import { IconNotApplicable } from "@app/components/icons/IconNotApplicable/IconNotApplicable";
import { AllReportsDataDialog } from "@app/pages/Features/GroupList/GroupDetail/MachineReportsHistoryTab/AllReportsDataDialog";
import { MachineReportDetailDialog } from "@app/pages/Features/GroupList/GroupDetail/MachineReportsHistoryTab/MachineReportDetailDialog";
import {
  SignatureDialog,
  getGroupIsSignatureRequired,
  uploadSignature,
} from "@app/pages/Features/MachineDetail/Components/Report/CreateReports";
import { MediaUploadMachineReportHistory } from "@app/pages/Features/GroupList/GroupDetail/Components/InspectionForm/MediaUpload/MediaUploadMachineReportHistory";

const TABLE_MAX_HEIGHT = 450;
const TABLE_MIN_WIDTH = 864;

type TableInspectionFormTabProps = {
  displayData: any;
  currentDate: Date;
  didScrollTop?: () => void;
  showDeleteRow: boolean;
  isEditing: boolean;
  onHeaderCellClick?: (inspectionIds: string[]) => void;
  setDisplayData: (data: any) => void;
  refreshInspectionData?: () => void;
  forceTableRefresh: number;
  onEditInspection?: (inspectionId: string) => void;
  onDownloadPdf: (
    inspectionId: string,
    headerRemarks?: string,
    footerRemarks?: string,
  ) => void;
  isLoading?: boolean;
};

export function TableInspectionFormTab({
  displayData,
  currentDate,
  didScrollTop,
  showDeleteRow,
  isEditing,
  onHeaderCellClick,
  setDisplayData,
  forceTableRefresh,
  refreshInspectionData,
  onEditInspection,
  onDownloadPdf,
  isLoading = false,
}: TableInspectionFormTabProps) {
  const { t } = useTranslation();
  const { userId: currentUserId } = useAppContext();
  const screenPermission = useSelector(
    (state: RootState) => state.screenPermission.value,
  );

  const [dataCell, setDataCell] = useState<Inspection>();

  const [open, setOpen] = useState(false);

  const [openDialogReport, setOpenDialogReport] = useState(false);

  const [dbMachine, setDbMachine] = useState<any>();

  const { groupId, machineId } = useParams();

  const tableContainerRef = useRef<HTMLTableElement>(null);
  const scrollPositionRef = useRef({ top: 0, left: 0 });
  const prevDateRef = useRef(currentDate);
  const isFirstDataLoadRef = useRef(true);

  const dispatch = useDispatch();

  const canEditOrDeleteInspection = useCallback(
    (record: { userId?: string | null; createdByUserId?: string | null }) => {
      const inspectionUserId = record?.userId || record?.createdByUserId;
      if (!inspectionUserId || !currentUserId) return false;

      const isOwnInspection = inspectionUserId === currentUserId;
      if (isOwnInspection) {
        return screenPermission?.allowEditDeleteInspectionResult === true;
      }
      return screenPermission?.allowEditDeleteOthersMachineReports === true;
    },
    [
      currentUserId,
      screenPermission?.allowEditDeleteInspectionResult,
      screenPermission?.allowEditDeleteOthersMachineReports,
    ],
  );

  // const [isPopupOpen, setIsPopupOpen] = useState(false);

  // const [selectedDate, setSelectedDate] = useState("");

  const convertHour = (time: Date) => {
    if (formatTime(time, "hh") === "12") {
      return `12:${formatTime(time, "mm")}`;
    }
    return formatTime(time, "hh:mm");
  };

  const handleTableScroll = () => {
    const el = tableContainerRef.current;
    if (!el) return;
    scrollPositionRef.current = {
      top: el.scrollTop,
      left: el.scrollLeft,
    };
  };

  useEffect(() => {
    const el = tableContainerRef.current;
    if (!el) return;

    const dateChanged = prevDateRef.current !== currentDate;
    prevDateRef.current = currentDate;

    if (dateChanged || isFirstDataLoadRef.current) {
      isFirstDataLoadRef.current = false;
      scrollPositionRef.current = { top: 0, left: 0 };
      resetScroll(el, () => {
        didScrollTop?.();
      });
      return;
    }

    const { top, left } = scrollPositionRef.current;
    requestAnimationFrame(() => {
      const container = tableContainerRef.current;
      if (!container) return;
      container.scrollTop = top;
      container.scrollLeft = left;
    });
  }, [displayData, currentDate, didScrollTop]);

  const [selectedInspectionId, setSelectedInspectionId] = useState<
    string | null
  >(null);

  const [openFormDelete, setOpenFormDelete] = useState(false);

  const [openFormNoMic, setOpenFormNoMic] = useState(false);

  const [openFormDeleteRecording, setOpenFormDeleteRecording] = useState(false);

  const { refreshMachineData } = useOutletContext<{
    refreshMachineData: () => void;
  }>();

  const [InspectiondialogOpen, setInspectionDialogOpen] = useState(false);
  const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
  const [isUpdatingInspectionItem, setIsUpdatingInspectionItem] =
    useState(false);

  const resetDialogs = () => {
    setDialogData(null);

    setInspectionDialogOpen(false);
  };

  const handleDeleteClick = (inspectionId: string) => {
    setSelectedInspectionId(inspectionId);
    setOpenFormDelete(true);
  };

  const [dialogData, setDialogData] = useState<{
    inspectionId: string;
    field: string;
    value: string;
    inspectionItemId?: string;
    result?: string;
    itemName?: string;
    comment?: string;
    resultType?: string;
    inspectionResultId?: string;
  } | null>(null);

  const confirmDelete = async () => {
    if (!selectedInspectionId || !groupId || !machineId) {
      console.error("Missing required parameters to delete inspection.");
      return;
    }

    try {
      await deleteInspection(groupId, machineId, selectedInspectionId);

      store.dispatch(setShowAlert(t("deleteinspectionsuccess")));

      setDisplayData((prevData: any) => {
        return prevData.map((row: any) => {
          const updatedRow = { ...row };
          Object.keys(updatedRow).forEach((key) => {
            if (Array.isArray(updatedRow[key])) {
              updatedRow[key] = updatedRow[key].filter(
                (record: any) => record.inspectionId !== selectedInspectionId,
              );
            }
          });
          return updatedRow;
        });
      });

      refreshMachineData();

      if (refreshInspectionData) {
        refreshInspectionData();
      }
      setOpenFormDelete(false);
    } catch (error) {
      console.error("Failed to delete inspection");
    }
  };

  const fieldMapping: Record<string, string> = {
    "عداد الخدمة (ساعة)": "SERVICE_METER",
    "Service meter/SMR (h)": "SERVICE_METER",
    "Horómetro/SMR (h)": "SERVICE_METER",
    "Compteur de service/SMR (h)": "SERVICE_METER",
    "サービスメーター/SMR（h）": "SERVICE_METER",
    "Horímetro (SMR)": "SERVICE_METER",
    "สروس میٹر (گھنٹہ)": "SERVICE_METER",
    "มิเตอร์บริการ/SMR (ชม.)": "SERVICE_METER",
    "ម៉ែត្របម្រើ/SMR (ម៉ោង)": "SERVICE_METER",
    "ມີ​ເຕີ້ບໍລິການ/SMR (ຊົ່ວໂມງ)": "SERVICE_METER",
    "Giờ máy/SMR (giờ)": "SERVICE_METER",

    "عداد المسافات (كم)": "ODOMETER",
    "Odometer (km)": "ODOMETER",
    "Odómetro (km)": "ODOMETER",
    "Compteur kilométrique (km)": "ODOMETER",
    "オドメーター（km）": "ODOMETER",
    "Odômetro (km)": "ODOMETER",
    "اوڈومیٹر (کلومیٹر)": "ODOMETER",
    "มาตรวัดระยะทาง (กม.)": "ODOMETER",
    "ឧបករណ៍វាស់ចម្ងាយ (គីឡូម៉ែត្រ)": "ODOMETER",
    "ມີ​ເຕີ້​ວັດ​ໄລ​ຍະ​ທາງ (km)": "ODOMETER",
    "Công tơ mét (km)": "ODOMETER",
  };

  // const handleCellClick = async (
  //   inspectionId: string,
  //   field: string,
  //   value: string,
  //   inspectionItemId?: string,
  //   inspectionResultId?: string,
  // ) => {
  //   if (field in fieldMapping) {
  //     try {
  //       const inspectionItemsResponse = await apiGetInspectionDetail(
  //         groupId ?? "",
  //         machineId ?? "",
  //         inspectionId,
  //       );
  //       const inspectionItems =
  //         inspectionItemsResponse.data.data.inspectionItems;

  //       const matchingItem = inspectionItems.find(
  //         (item: any) => item.itemCode === fieldMapping[field],
  //       );

  //       if (!matchingItem) {
  //         console.error("Matching item not found for field:", field);
  //         return;
  //       }

  //       setInspectionDialogOpen(false);

  //       const localizedField =
  //         Object.keys(fieldMapping).find(
  //           (key) =>
  //             fieldMapping[key] === matchingItem.itemCode && key === field,
  //         ) || field;

  //       setDialogData({
  //         inspectionId,
  //         field: localizedField,
  //         value: matchingItem.result ?? value,
  //         inspectionItemId: matchingItem.inspectionItemId,
  //         inspectionResultId: matchingItem.inspectionResultId,
  //       });
  //       setInspectionDialogOpen(false);
  //     } catch (error) {
  //       console.error("Failed to fetch inspection details:", error);
  //     }
  //   }
  // };

  const handleUpdateInspection = async () => {
    if (!dialogData || !groupId || !machineId) {
      console.error("Missing required parameters for update:", {
        groupId,
        machineId,
        dialogData,
      });
      return;
    }

    try {
      if (!dialogData.inspectionItemId) {
        console.error("Missing inspectionItemId:", dialogData.inspectionItemId);
        return;
      }
      if (!dialogData.inspectionResultId) {
        console.error(
          "Missing inspectionResultId:",
          dialogData.inspectionResultId,
        );
        return;
      }

      const inspectionItemDetailResponse = await apiGetInspectionItemDetail(
        groupId,
        machineId,
        dialogData.inspectionId,
        dialogData.inspectionItemId,
      );

      const detailData = inspectionItemDetailResponse.data.data;
      const rawItems = detailData?.inspectionItems;
      const inspectionItemDetail = Array.isArray(rawItems)
        ? (rawItems.find(
            (it: any) =>
              it.inspectionItemId === dialogData.inspectionItemId ||
              it.inspectionResultId === dialogData.inspectionResultId,
          ) ?? rawItems[0])
        : rawItems && typeof rawItems === "object"
          ? rawItems
          : detailData;

      if (!inspectionItemDetail) {
        console.error("Inspection item detail not found for update");
        return;
      }

      const updatedPayload = {
        ...inspectionItemDetail,
        result: dialogData.value,
        freeText: null,
        machineReport: inspectionItemDetail.machineReport ?? null,
      };

      await apiUpdateInspectionItem(
        groupId,
        machineId,
        dialogData.inspectionId,
        dialogData.inspectionResultId,
        updatedPayload,
      );

      store.dispatch(setShowAlert(t("updateinspectionsuccess")));

      const updatedResponse = await apiGetInspectionItemDetail(
        groupId,
        machineId,
        dialogData.inspectionId,
        dialogData.inspectionItemId,
      );

      const updatedRawItems = updatedResponse.data.data?.inspectionItems;
      const updatedInspectionItem = Array.isArray(updatedRawItems)
        ? (updatedRawItems.find(
            (it: any) =>
              it.inspectionItemId === dialogData.inspectionItemId ||
              it.inspectionResultId === dialogData.inspectionResultId,
          ) ?? updatedRawItems[0])
        : updatedRawItems && typeof updatedRawItems === "object"
          ? updatedRawItems
          : updatedResponse.data.data;

      const itemCode =
        fieldMapping[dialogData.field] || updatedInspectionItem?.itemCode;

      setDisplayData((prevData: any) =>
        prevData.map((row: any) => {
          const updatedRow = { ...row };
          Object.keys(updatedRow).forEach((key) => {
            if (Array.isArray(updatedRow[key])) {
              updatedRow[key] = updatedRow[key].map((record: any) => {
                if (record.inspectionId === dialogData.inspectionId) {
                  const updatedResults = (record.inspectionResults || []).map(
                    (result: any) => {
                      if (
                        result.inspectionResultId ===
                        dialogData.inspectionResultId
                      ) {
                        return { ...result, ...updatedInspectionItem };
                      }
                      return result;
                    },
                  );

                  return {
                    ...record,
                    inspectionResults: updatedResults,
                    ...(itemCode === "SERVICE_METER"
                      ? { serviceMeterValue: dialogData.value }
                      : {}),
                    ...(itemCode === "ODOMETER"
                      ? { odometerValue: dialogData.value }
                      : {}),
                  };
                }
                return record;
              });
            }
          });
          return updatedRow;
        }),
      );

      refreshMachineData();

      if (refreshInspectionData) {
        refreshInspectionData();
      }
      resetDialogs();
    } catch (error: any) {
      if (error.response) {
        console.error("API Error Response:", error.response);
      } else if (error.request) {
        console.error("API Error Request:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  type MachineReportMedia = {
    filePath: string;
    fileName: string;
    mediaUrl: string;
    mimeType: string;
    captureMediaAt: string;
  };
  const [fileCount, setFileCount] = useState(0);

  const [removedMediaUrls, setRemovedMediaUrls] = useState<string[]>([]);

  type InspectionItemOption = {
    customInspectionItemsOptionsId?: string;
    name: string;
    position?: number;
    selected?: boolean;
  };

  const [selectedInspection, setSelectedInspection] = useState<{
    inspectionId: string;
    inspectionAt: string;
    machineId: string;
    groupId: string;
    resultType: string;
    resultValue: string;
    itemName: string;
    comment: string;
    freeText?: string | null;
    options?: InspectionItemOption[] | null;
    inspectionItemId: string;
    machineReport?: {
      machineReportId: string;
      reportTitle: string;
      reportComment: string;
      currentStatus: string;
      machineReportMedias?: Array<{
        machineReportMediaId: any;
        fileName: string;
        filePath: string;
        mediaUrl: string;
        mimeType: string;
        captureMediaAt: string;
      }>;
    } | null;
  } | null>(null);

  const [inspectionName, setInspectionName] = useState("");

  const [inspectionTime, setInspectionTime] = useState("");

  const [inspectionComment, setInspectionComment] = useState("");
  const [selectedFreeText, setSelectedFreeText] = useState("");

  const [resultValue, setResultValue] = useState("OK");

  const [mediaFiles, setMediaFiles] = useState<File[]>([]);

  //const [totalMediaCount, setTotalMediaCount] = useState(0);
  const [totalMediaCount] = useState(0);

  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState<any>(null);

  const [recordedBlob, setRecordedBlob] = useState<Blob | null>(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const recordingStartTimeRef = useRef<number | null>(null);
  const recordingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [mediaAvailable, setMediaAvailable] = useState(true);
  const [recordingInterval, setRecordingInterval] = useState<any>(null);
  const [isPaused, setIsPaused] = useState(false);
  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);
  const [existingRecordingDeleted, setExistingRecordingDeleted] =
    useState(false);
  const stoppedRef = useRef(false);

  type RecordingFile = {
    fileName: string;
    recordingUrl: string;
    filePath: string;
    mimeType: string;
    recordingAt: string;
  };
  const [recordingFiles, setRecordingFiles] = useState<RecordingFile[]>([]);
  const [, setRecordingCount] = useState(0);

  // const InspectionItemDialogOpen = async (
  //   record: { inspectionId: string; inspectionResults: any[] },
  //   row: { customInspectionItemId: string },
  //   isEditing: boolean,
  //   groupId: string | undefined,
  //   machineId: string | undefined,
  // ) => {
  //   if (!isEditing) return;

  //   const inspectionId = record.inspectionId;

  //   if (inspectionId && groupId && machineId) {
  //     try {
  //       setInspectionName("");
  //       setInspectionTime("");
  //       setInspectionComment("");
  //       setSelectedFreeText("");
  //       setResultValue("");
  //       setMediaFiles([]);
  //       setFileCount(0);
  //       setSelectedInspection(null);

  //       setMediaFiles([]);
  //       const response = await apiGetInspectionDetail(
  //         groupId,
  //         machineId,
  //         inspectionId,
  //       );
  //       const inspectionAt = response?.data?.data?.lastStatusUpdatedAt;

  //       const formattedInspectionAt = format(
  //         new Date(inspectionAt),
  //         userTimeFormat,
  //       );
  //       const inspectionItems = response.data.data.inspectionItems;

  //       const totalCount = inspectionItems.reduce(
  //         (acc: number, item: any) =>
  //           acc + (item.machineReport?.machineReportMedias?.length || 0),
  //         0,
  //       );

  //       const inspectionItem = inspectionItems.find(
  //         (item: { inspectionItemId: string }) =>
  //           item.inspectionItemId === row.customInspectionItemId,
  //       );

  //       if (inspectionItem) {
  //         const mediaFiles =
  //           inspectionItem.machineReport?.machineReportMedias?.map(
  //             (media: {
  //               fileName: string;
  //               mediaUrl: string;
  //               mimeType: string;
  //               filePath: string;
  //               thumbnailUrl: string;
  //               captureMediaAt: string;
  //             }) => ({
  //               fileName: media.fileName,
  //               mediaUrl: media.mediaUrl,
  //               filePath: media.filePath,
  //               mimeType: media.mimeType,
  //               thumbnailUrl: media.thumbnailUrl,
  //               captureMediaAt: media.captureMediaAt,
  //             }),
  //           ) || [];

  //         setMediaFiles(mediaFiles);
  //         const recordingFiles =
  //           inspectionItem.machineReport?.machineReportRecordings?.map(
  //             (recording: {
  //               fileName: string;
  //               recordingUrl: string;
  //               mimeType: string;
  //               filePath: string;
  //               recordingAt: string;
  //             }) => ({
  //               fileName: recording.fileName,
  //               recordingUrl: recording.recordingUrl,
  //               filePath: recording.filePath,
  //               mimeType: recording.mimeType,
  //               recordingAt: recording.recordingAt,
  //             }),
  //           ) || [];

  //         setRecordingFiles(recordingFiles);
  //         setRecordingCount(recordingFiles.length);

  //         const { name, machineReport, result, freeText, options } =
  //           inspectionItem;
  //         const normalizedFreeText = freeText || "";

  //         setInspectionName(name || "");
  //         setInspectionTime(formattedInspectionAt || "");
  //         setInspectionComment(
  //           machineReport?.reportComment || normalizedFreeText,
  //         );
  //         setSelectedFreeText(normalizedFreeText);
  //         setResultValue(result || "");
  //         setSelectedInspection({
  //           ...inspectionItem,
  //           freeText: normalizedFreeText,
  //           options,
  //           machineReport: {
  //             ...machineReport,
  //             machineReportMedias: mediaFiles,
  //             machineReportRecordings: recordingFiles,
  //           },
  //         });
  //         setMediaFiles(mediaFiles);
  //         setFileCount(mediaFiles.length);
  //         setTotalMediaCount(totalCount - mediaFiles.length);

  //         setInspectionDialogOpen(true);
  //       } else {
  //         console.warn("Inspection item not found for the selected row.");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching inspection details:", error);
  //     }
  //   }
  // };

  const performUpdateInspectionItem = async (
    signatureDataUrl: string | null,
  ) => {
    if (
      !selectedInspection ||
      !selectedInspection.inspectionId ||
      !selectedInspection.inspectionItemId
    ) {
      return;
    }
    if (!groupId || !machineId) {
      return;
    }

    const { inspectionId, inspectionItemId } = selectedInspection;

    try {
      const response = await apiGetInspectionDetail(
        groupId,
        machineId,
        inspectionId,
      );
      const inspectionItems = response.data.data.inspectionItems;

      const selectedInspectionItem = inspectionItems.find(
        (item: { inspectionItemId: string }) =>
          item.inspectionItemId === inspectionItemId,
      );

      if (!selectedInspectionItem) {
        return;
      }

      const originalComment =
        selectedInspectionItem.machineReport?.reportComment || "";
      const originalFreeText = selectedInspectionItem.freeText || "";

      const originalResult = selectedInspectionItem.result;

      const originalRecordings =
        selectedInspectionItem.machineReport?.machineReportRecordings || [];

      const commentChanged = inspectionComment !== originalComment;
      const freeTextChanged = selectedFreeText !== originalFreeText;
      const resultChanged = resultValue !== originalResult;
      const mediaRemoved = removedMediaUrls.length > 0;
      const mediaAdded = mediaFiles.length > 0;
      const recordingsDeleted = existingRecordingDeleted;
      const recordingsAdded =
        recordedBlob || recordingFiles.length > originalRecordings.length;

      const hasChanges =
        commentChanged ||
        freeTextChanged ||
        resultChanged ||
        mediaRemoved ||
        mediaAdded ||
        recordingsDeleted ||
        recordingsAdded;

      if (hasChanges) {
        let machineReportMedias: MachineReportMedia[] =
          selectedInspectionItem.machineReport?.machineReportMedias || [];

        machineReportMedias = machineReportMedias.filter(
          (media) => !removedMediaUrls.includes(media.filePath),
        );

        if (mediaFiles.length > 0) {
          const uploadedMedias = await handleConvertMedia1(mediaFiles);
          machineReportMedias = [...machineReportMedias, ...uploadedMedias];
        } else if (fileCount === 0) {
          machineReportMedias = [];
        }

        let machineReportRecordings: any[] = existingRecordingDeleted
          ? []
          : [...recordingFiles];

        if (recordedBlob) {
          const audioFile = new File(
            [recordedBlob],
            `recording_${Date.now()}.webm`,
            { type: "audio/webm" },
          );

          const uploadedAudio = await handleUploadStore(
            UploadFileType.MACHINE_REPORT,
            audioFile,
          );

          if (uploadedAudio) {
            const audioRecording = {
              fileName: uploadedAudio.name || uploadedAudio.fileName,
              filePath: uploadedAudio.filePath,
              recordingUrl: uploadedAudio.filePath,
              mimeType: uploadedAudio.type || uploadedAudio.mimeType,
              recordingAt: new Date().toISOString(),
            };

            machineReportRecordings.push(audioRecording);
          } else {
            console.warn("Audio upload failed.");
          }
        }

        let signatureUrl: string | undefined;
        if (resultValue === ItemResultType.ANOMARY && signatureDataUrl) {
          signatureUrl = await uploadSignature(signatureDataUrl);
        }

        const fallbackComment =
          resultValue === ItemResultType.FREE_TEXT && !inspectionComment.trim()
            ? selectedFreeText.trim()
            : inspectionComment;

        const machineReport =
          machineReportMedias.length > 0 ||
          machineReportRecordings.length > 0 ||
          fallbackComment ||
          (resultValue !== "OK" &&
            resultValue !== "NOT_APPLICABLE" &&
            resultValue !== "NONE")
            ? {
                reportTitle: selectedInspectionItem.name,
                reportComment: fallbackComment || "",
                inspectionResultId: selectedInspectionItem.inspectionResultId,
                machineReportMedias,
                machineReportRecordings,
                ...(signatureUrl ? { signatureUrl } : {}),
              }
            : null;

        const updatedPayload = {
          ...selectedInspectionItem,
          result: resultValue,
          freeText:
            resultValue === ItemResultType.FREE_TEXT
              ? selectedFreeText || null
              : null,
          machineReport,
        };

        await apiUpdateInspectionItem(
          groupId,
          machineId,
          inspectionId,
          selectedInspectionItem.inspectionResultId,
          updatedPayload,
        );
        store.dispatch(setShowAlert(t("updateinspectionsuccess")));
      }

      setInspectionDialogOpen(false);
      setFileCount(0);
      setMediaFiles([]);
      setInspectionName("");
      setInspectionTime("");
      setInspectionComment("");
      setSelectedFreeText("");
      setResultValue("");
      setSelectedInspection(null);
      setRemovedMediaUrls([]);

      refreshMachineData();

      if (refreshInspectionData) {
        refreshInspectionData();
      }

      if (isRecording || isPaused) {
        stopRecording();
      }

      setRecordedBlob(null);
      setRecordingTime(0);
      setIsPaused(false);
      setIsRecording(false);
      setRecorder(null);
      setRecordingInterval(null);
      setMediaAvailable(true);

      setRecordingFiles([]);
      setRecordingCount(0);
      setExistingRecordingDeleted(false);
    } catch (error) {
      console.error("Error updating inspection item:", error);
      throw error;
    }
  };

  const handleUpdateInspectionItemClick = async () => {
    if (resultValue === ItemResultType.ANOMARY) {
      if (!groupId) {
        return;
      }

      const isSignatureRequired = await getGroupIsSignatureRequired(groupId);
      if (isSignatureRequired) {
        setSignatureDialogOpen(true);
        return;
      }
    }

    void runInspectionItemUpdate(null);
  };

  const handleSignatureUpdateSend = async (signatureDataUrl: string | null) => {
    await runInspectionItemUpdate(signatureDataUrl);
    setSignatureDialogOpen(false);
  };

  const runInspectionItemUpdate = async (signatureDataUrl: string | null) => {
    setIsUpdatingInspectionItem(true);
    try {
      await performUpdateInspectionItem(signatureDataUrl);
    } catch {
      store.dispatch(
        setShowAlert(t("Anunexpectederroroccurredwhileprocessingthefile")),
      );
    } finally {
      setIsUpdatingInspectionItem(false);
    }
  };

  const handleConvertMedia1 = async (
    files: File[],
  ): Promise<MachineReportMedia[]> => {
    const array: (MachineReportMedia | null)[] = [];
    for await (const item of files) {
      const newItem = (await handleUploadStore(
        UploadFileType.MACHINE_REPORT,
        item,
      )) as any;
      array.push(
        newItem
          ? {
              fileName: newItem?.name || newItem?.fileName,
              filePath: newItem?.filePath,
              mediaUrl: newItem?.filePath,
              mimeType: newItem?.type || newItem?.mimeType,

              captureMediaAt: new Date(newItem.lastModified).toISOString(),
            }
          : null,
      );
    }

    return array.filter((item): item is MachineReportMedia => item !== null);
  };

  // const updateInspectionAt = async () => {
  //   try {
  //     if (!selectedInspectionId) {
  //       return;
  //     }
  //     if (!groupId || !machineId) {
  //       return;
  //     }
  //     const formattedDateTime = getFormattedDateTime();
  //     if (!formattedDateTime) {
  //       return;
  //     }
  //     await apiUpdateInspectionAt(groupId, machineId, selectedInspectionId, {
  //       inspectionAt: formattedDateTime,
  //     });
  //     store.dispatch(setShowAlert(t("updateinspectionsuccesstime")));

  //     refreshMachineData();
  //     if (refreshInspectionData) {
  //       refreshInspectionData();
  //     }
  //     handleClosePopup();
  //   } catch (error) {}
  // };

  const [refreshKey] = useState(0);

  const uploadDescription1 = [
    `${t("dialogReport.pleaseUploadFile")}`,
    `<span class="fs-12">${t("dialogReport.thatCanBeUploadedAre")}</span>`,
    `<span class="fs-12">${t(
      "dialogReport.fileFormatsMachineReportHistory",
    )}</span>`,
    `<span class="fs-12">${t("dialogReport.videosCanBeUploaded")}</span>`,
  ];

  const [downloadingMap, setDownloadingMap] = useState<{
    [key: string]: boolean;
  }>({});

  // const [selectedTime, setSelectedTime] = useState(() => {
  //   const now = new Date();
  //   const hours = now.getHours();
  //   const minutes = now.getMinutes();
  //   const period = hours >= 12 ? "PM" : "AM";
  //   const formattedHours = hours % 12 || 12;
  //   const formattedMinutes = minutes.toString().padStart(2, "0");
  //   const formattedTime = `${formattedHours}:${formattedMinutes} ${period}`;
  //   return formattedTime;
  // });

  // const handleClosePopup = () => {
  //   setIsPopupOpen(false);
  //   setSelectedDate("");
  //   setSelectedTime("");
  //   setSelectedInspectionId(null);
  // };

  // const [valueStartDate, setValueStartDate] = useState(() => {
  //   const date = new Date();
  //   date.setDate(date.getDate());
  //   return date;
  // });

  // const handleChangeStartDate = (newValue: Date) => {
  //   const formattedDate = new Intl.DateTimeFormat("en-CA", {
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //   }).format(newValue);
  //   setSelectedDate(formattedDate);
  // };

  // const getFormattedDateTime = () => {
  //   if (!selectedDate || !selectedTime) {
  //     console.error("Invalid date or time:", { selectedDate, selectedTime });
  //     return "";
  //   }

  //   const combinedDate = new Date(`${selectedDate}T${selectedTime}`);
  //   if (isNaN(combinedDate.getTime())) {
  //     console.error("Invalid combined date/time value:", combinedDate);
  //     return "";
  //   }

  //   return formatISO(combinedDate, { representation: "complete" });
  // };

  // const handleOpenPopup = async (
  //   inspectionId: string,
  //   groupId: string,
  //   machineId: string,
  // ) => {
  //   try {
  //     const response = await apiGetInspectionAt(
  //       groupId,
  //       machineId,
  //       inspectionId,
  //     );
  //     const inspectionAt = response.data.data.inspectionAt;

  //     if (!inspectionAt) {
  //       throw new Error("Invalid inspectionAt value received from API.");
  //     }

  //     const inspectionAtUTC = inspectionAt.includes("Z")
  //       ? inspectionAt
  //       : `${inspectionAt}Z`;
  //     const parsedDate = new Date(inspectionAtUTC);

  //     if (isNaN(parsedDate.getTime())) {
  //       throw new Error(
  //         "Failed to parse inspectionAt into a valid Date object.",
  //       );
  //     }

  //     const formattedDate = parsedDate.toLocaleDateString("en-CA", {
  //       year: "numeric",
  //       month: "2-digit",
  //       day: "2-digit",
  //     });

  //     const hours = parsedDate.getHours().toString().padStart(2, "0");
  //     const minutes = parsedDate.getMinutes().toString().padStart(2, "0");
  //     const formattedTime = `${hours}:${minutes}`;

  //     setValueStartDate(parsedDate);
  //     setSelectedDate(formattedDate);
  //     setSelectedTime(formattedTime);
  //     setSelectedInspectionId(inspectionId);
  //     setIsPopupOpen(true);
  //   } catch (error) {
  //     console.error("Error in handleOpenPopup:", error);
  //   }
  // };

  const handlePreviewMedia = (mediaUrls: string[]) => {};

  const [error, setError] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const isInvalid =
      !REGEX.commonNameFieldCharacterMuiltiLineRegex.test(value) ||
      !REGEX.emojiRegex.test(value);

    setInspectionComment(value);

    if (isInvalid) {
      setError(true);
    } else {
      setError(false);
    }
  };

  const sortedSelectedInspectionOptions = useMemo(
    () =>
      [...(selectedInspection?.options ?? [])].sort(
        (a, b) => (a.position ?? 0) - (b.position ?? 0),
      ),
    [selectedInspection?.options],
  );

  const [userTimeFormat, setUserTimeFormat] =
    useState<string>("yyyy/MM/dd HH:mm");
  const [localeCode, setLocaleCode] = useState("en");
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await getUser();
        let timeFormat = response?.data?.data?.timeFormat || "yyyy/MM/dd";
        let isoLocaleCode = response?.data?.data?.isoLocaleCode;

        if (!timeFormat.includes("HH") && !timeFormat.includes("mm")) {
          timeFormat += " HH:mm";
        }

        setLocaleCode(isoLocaleCode);
        setUserTimeFormat(timeFormat);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const [machineReportId, setMachineReportId] = useState<string>();

  const [, setIsFormChanged] = useState(false);

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClickIconReport = async (machineReportId: string | null) => {
    if (!machineReportId) {
      console.warn("No machine report available for this item.");

      return;
    }

    if (groupId && machineId) {
      try {
        const db = await getMachineReportDetail(
          groupId,
          machineId,
          machineReportId,
        );

        setDbMachine(db);
        setOpenDialogReport(true);

        if (!db?.isRead) {
          await updateMachineReportStatus(
            groupId,
            machineId,
            machineReportId,
            true,
          );

          dispatch(setIsUpdatedMachineReportResponses(`${new Date()}`));
        }
      } catch (error) {
        console.error("Failed to fetch machine report details. Error:", error);
      }
    } else {
      console.error("Missing groupId or machineId");
    }
  };

  const [dialogKey, setDialogKey] = useState<number>(0);
  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setMachineReportId("");
  };

  const getMachineReportId = async (id: string) => {
    try {
      setMachineReportId(id);
      setIsDialogOpen(true);
      setDialogKey((prev) => prev + 1);
    } catch (error) {
      console.error("Error fetching Machine Report:", error);
    }
  };

  const [hasUploadError, setHasUploadError] = useState(false);

  const [InspectionPDFdialogOpen, setInspectionPDFdialogOpen] = useState(false);
  const [pdfHeaderRemarks, setPdfHeaderRemarks] = useState("");
  const [pdfFooterRemarks, setPdfFooterRemarks] = useState("");
  const [pdfHeaderRemarksError, setPdfHeaderRemarksError] = useState(false);
  const [pdfFooterRemarksError, setPdfFooterRemarksError] = useState(false);

  const handleInputPdfHeaderChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = e.target.value;
    const isInvalid =
      !REGEX.commonNameFieldCharacterMuiltiLineRegex.test(value) ||
      !REGEX.emojiRegex.test(value);

    setPdfHeaderRemarks(value);
    setPdfHeaderRemarksError(isInvalid);
  };

  const handleInputPdfFooterChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = e.target.value;
    const isInvalid =
      !REGEX.commonNameFieldCharacterMuiltiLineRegex.test(value) ||
      !REGEX.emojiRegex.test(value);

    setPdfFooterRemarks(value);
    setPdfFooterRemarksError(isInvalid);
  };

  const [selectedInspectionIdPDF, setSelectedInspectionIdPDF] = useState<
    string | null
  >(null);

  const handleDownloadClick = async (inspectionId: string) => {
    if (downloadingMap[inspectionId]) {
      console.warn(
        `Download already in progress for Inspection ID: ${inspectionId}`,
      );
      return;
    }

    if (!inspectionId || !groupId || !machineId) {
      console.error("Missing required parameters");
      return;
    }

    setDownloadingMap((prev) => ({ ...prev, [inspectionId]: true }));

    try {
      await onDownloadPdf(inspectionId, pdfHeaderRemarks, pdfFooterRemarks);

      setSelectedInspectionIdPDF(null);
      setPdfHeaderRemarks("");
      setPdfFooterRemarks("");
      setInspectionPDFdialogOpen(false);
    } catch (error) {
      console.error(
        `Error downloading PDF for Inspection ID: ${inspectionId}`,
        error,
      );
    } finally {
      setDownloadingMap((prev) => ({ ...prev, [inspectionId]: false }));
    }
  };

  const startRecording = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasMic = devices.some((device) => device.kind === "audioinput");

      if (!hasMic) {
        setOpenFormNoMic(true);
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      setMediaStream(stream);

      if (recorder?.stream) {
        recorder.stream
          .getTracks()
          .forEach((track: MediaStreamTrack) => track.stop());
      }

      setIsPaused(false);
      setRecordedBlob(null);
      stoppedRef.current = false;

      const newRecorder = new RecordRTC(stream, {
        type: "audio",
        mimeType: "audio/webm",
        recorderType: RecordRTC.StereoAudioRecorder,
        numberOfAudioChannels: 1,
        desiredSampRate: 16000,
        audioBitsPerSecond: 64000,
      });

      recordingStartTimeRef.current = Date.now();
      newRecorder.startRecording();
      setRecorder(newRecorder);
      setIsRecording(true);
      setRecordingTime(0);

      const interval = setInterval(() => {
        if (recordingStartTimeRef.current) {
          const elapsed = Math.floor(
            (Date.now() - recordingStartTimeRef.current) / 1000,
          );
          setRecordingTime(Math.min(elapsed, 60));
        }
      }, 1000);

      setRecordingInterval(interval);

      const timeout = setTimeout(() => {
        stopRecording();
      }, 59200);

      recordingTimeoutRef.current = timeout;
    } catch (err) {
      console.warn("Microphone access denied", err);
      setMediaAvailable(false);
    }
  };

  const [pdfConfirmOpen, setPdfConfirmOpen] = useState(false);
  const [pendingPDFType, setPendingPDFType] = useState<"INSPECTION" | null>(
    null,
  );

  const stopRecording = useCallback(() => {
    if (!recorder) return;

    stoppedRef.current = true;

    setIsRecording(false);
    setIsPaused(false);
    clearInterval(recordingInterval);
    if (recordingTimeoutRef.current) clearTimeout(recordingTimeoutRef.current);
    recorder.stopRecording(() => {
      const blob = recorder.getBlob();
      if (blob && blob.size > 0) {
        setRecordedBlob(blob);
      }

      if (mediaStream) {
        mediaStream
          .getTracks()
          .forEach((track: MediaStreamTrack) => track.stop());
        setMediaStream(null);
      }

      setRecorder(null);
      recordingStartTimeRef.current = null;
    });
  }, [recorder, recordingInterval, mediaStream]);

  useEffect(() => {
    if (recordingTime >= 60 && isRecording && !stoppedRef.current) {
      stopRecording();
    }
  }, [recordingTime, isRecording, stopRecording]);

  const handleDeleteRecording = () => {
    if (isRecording || isPaused) {
      stopRecording();
    }

    if (mediaStream) {
      mediaStream.getTracks().forEach((track) => {
        if (track.readyState === "live") {
          track.stop();
        }
      });
      setMediaStream(null);
    }

    if (recordingTimeoutRef.current) clearTimeout(recordingTimeoutRef.current);

    setRecordedBlob(null);
    setRecordingTime(0);
    setIsPaused(false);
    setIsRecording(false);
    setRecorder(null);
    setRecordingInterval(null);
    setMediaAvailable(true);

    setRecordingFiles([]);
    setRecordingCount(0);
    setExistingRecordingDeleted(true);
    setOpenFormDeleteRecording(false);
    recordingStartTimeRef.current = null;
  };

  const recordedBlobUrl = useMemo(() => {
    return recordedBlob ? URL.createObjectURL(recordedBlob) : null;
  }, [recordedBlob]);
  useEffect(() => {
    return () => {
      if (recordedBlobUrl) {
        URL.revokeObjectURL(recordedBlobUrl);
      }
    };
  }, [recordedBlobUrl]);

  useEffect(() => {
    const hasAudio = !!recordedBlob || recordingFiles.length > 0;
    setIsFormChanged(hasAudio);
  }, [recordedBlob, recordingFiles]);

  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const stickyInspectionColumnEdge = isRTL ? { right: 0 } : { left: 0 };
  const stickyInspectionColumnMinWidth = 197;
  /** Lock column width — min-only lets the flex+tooltip layout stretch the column. */
  const stickyInspectionColumnSize = {
    minWidth: stickyInspectionColumnMinWidth,
    maxWidth: stickyInspectionColumnMinWidth,
    width: stickyInspectionColumnMinWidth,
    boxSizing: "border-box" as const,
  };
  const stickyInspectionColumnTextAlign = isRTL
    ? ("right" as const)
    : ("left" as const);
  const stickyInspectionColumnCellSx = {
    textAlign: stickyInspectionColumnTextAlign,
    direction: (isRTL ? "rtl" : "ltr") as "rtl" | "ltr",
  };
  const stickyInspectionColumnHeaderContentSx = {
    width: "100%",
    display: "flex",
    justifyContent: (isRTL ? "flex-end" : "flex-start") as
      | "flex-end"
      | "flex-start",
    textAlign: stickyInspectionColumnTextAlign,
  };
  return (
    <>
      <DataDialog
        open={InspectiondialogOpen}
        setOpen={() => setInspectionDialogOpen(false)}
        disableBackdropClick={true}
        disableEnforceFocus
        title={
          <p
            style={{
              fontWeight: "bold",
              fontSize: "24px",
              marginBottom: "0px",
              marginTop: "0px",
              color: "black",
            }}
          >
            {inspectionName}
          </p>
        }
        subTitle={
          <p
            style={{
              color: "#A0A0A0",
              fontSize: "13px",
              margin: "2px",
            }}
          >
            {inspectionTime}
          </p>
        }
        className="dialog-container"
      >
        {selectedInspection?.resultType !== "NONE" && (
          <div className="radio-group-container">
            <div
              style={{
                display: "flex",
                gap: "20px",
                alignItems: "center",
                marginTop: "0px",
              }}
            >
              {(selectedInspection?.resultType === "OK_OR_ANOMARY" ||
                selectedInspection?.resultType ===
                  "OK_ANOMARY_NOT_APPLICABLE") && (
                <>
                  <Tooltip title={t("normal")} arrow>
                    <Box
                      onClick={() => setResultValue("OK")}
                      sx={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <IconSelectedNew
                        fillColor={resultValue === "OK" ? "#0e7c47" : "#DAFBE1"}
                        iconColor={resultValue === "OK" ? "white" : "#1A7F37"}
                      />
                    </Box>
                  </Tooltip>

                  <Tooltip title={t("abnormal")} arrow>
                    <Box
                      onClick={() => setResultValue("ANOMARY")}
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <IconMaintenaceNew
                        fillColor={
                          resultValue === "ANOMARY" ? "#DA9309" : "#FFF8C5"
                        }
                        iconColor={
                          resultValue === "ANOMARY" ? "white" : "#DA9309"
                        }
                      />
                    </Box>
                  </Tooltip>
                </>
              )}

              {selectedInspection?.resultType ===
                "OK_ANOMARY_NOT_APPLICABLE" && (
                <Tooltip title={t("notapplicable")} arrow>
                  <Box
                    onClick={() => setResultValue("NOT_APPLICABLE")}
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      transition: "all 0.2s ease-in-out",
                    }}
                  >
                    <IconNotApplicableDashInspection
                      fillColor={
                        resultValue === "NOT_APPLICABLE" ? "#696969" : "#D3D3D3"
                      }
                      dashColor="white"
                      size={resultValue === "NOT_APPLICABLE" ? 44 : 37}
                    />
                  </Box>
                </Tooltip>
              )}
            </div>
          </div>
        )}

        <div style={{ marginTop: "20px" }}></div>

        <div
          className="wrapper-text-field mt-8"
          style={{ position: "relative" }}
        >
          <TextField
            multiline
            rows={3}
            className="input-field"
            label={t("dialogReport.comment")}
            value={inspectionComment}
            fullWidth
            disabled={
              selectedInspection?.resultType === ItemResultType.FREE_TEXT
            }
            inputProps={{ maxLength: 1000 }}
            onChange={handleInputChange}
            error={error}
            helperText={error ? t("invalidCharacters") : ""}
            InputProps={{
              style: {
                paddingRight: "65px",
              },
            }}
          />

          {mediaAvailable && !recordedBlob && recordingFiles.length === 0 && (
            <div
              style={{
                position: "absolute",
                right: 12,
                top: 40,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                zIndex: 10,
                pointerEvents: "auto",
              }}
            >
              {!isRecording && !isPaused ? (
                <Tooltip title={t("start")}>
                  <FiberManualRecordIcon
                    onClick={recordingTime >= 60 ? undefined : startRecording}
                    sx={{
                      color: recordingTime >= 60 ? "#ccc" : "#d32f2f",
                      cursor: recordingTime >= 60 ? "not-allowed" : "pointer",
                      pointerEvents: recordingTime >= 60 ? "none" : "auto",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: recordingTime >= 60 ? "#ccc" : "#a30000",
                        transform: recordingTime >= 60 ? "none" : "scale(1.1)",
                      },
                    }}
                  />
                </Tooltip>
              ) : (
                <>
                  <Tooltip title={t("stop")}>
                    <StopIcon
                      onClick={stopRecording}
                      sx={{
                        color: "#d32f2f",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          color: "#a30000",
                          transform: "scale(1.1)",
                        },
                      }}
                    />
                  </Tooltip>
                </>
              )}
            </div>
          )}

          {error && <span className="error-text fs-12 ml-15 txt-red"></span>}
        </div>

        {selectedInspection?.resultType === ItemResultType.FREE_TEXT &&
          sortedSelectedInspectionOptions.length > 0 && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="inspection-free-text-select-label">
                {t("predefinedCommentSelection")}
              </InputLabel>
              <Select
                labelId="inspection-free-text-select-label"
                value={selectedFreeText}
                label={t("predefinedCommentSelection")}
                onChange={(e) => {
                  const value = e.target.value as string;
                  setSelectedFreeText(value);
                  setInspectionComment(value);
                  setError(false);
                }}
              >
                <MenuItem value="">
                  <em>{t("pleaseSelect")}</em>
                </MenuItem>
                {sortedSelectedInspectionOptions.map((option) => (
                  <MenuItem
                    key={option.customInspectionItemsOptionsId || option.name}
                    value={option.name}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

        {isRecording && recordingTime < 60 && (
          <Tooltip title={t("recording")} arrow>
            <div
              className="glow-red"
              style={{
                marginTop: "4px",
                fontSize: "12px",
                color: "#d32f2f",
                backgroundColor: "#ffe6e6",
                padding: "4px 8px",
                borderRadius: "4px",
                boxShadow: "0 0 8px #f44336",
                fontWeight: "bold",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                height: "32px",
              }}
            >
              <FiberManualRecordIcon fontSize="small" />

              <span
                style={{ transform: "translateY(1px)" }}
              >{`${recordingTime}s`}</span>
            </div>
          </Tooltip>
        )}

        {isPaused && (
          <Tooltip title={t("paused")} arrow>
            <div
              className="glow-yellow"
              style={{
                marginTop: "4px",
                fontSize: "12px",
                color: "#f9a825",
                backgroundColor: "#fff8e1",
                padding: "4px 8px",
                borderRadius: "4px",
                boxShadow: "0 0 8px #fbc02d",
                fontWeight: "bold",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                height: "32px",
              }}
            >
              <PauseCircleIcon fontSize="small" />
              {`${recordingTime}s`}
            </div>
          </Tooltip>
        )}

        {recordedBlob ? (
          <div
            style={{
              marginTop: "12px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <audio controls src={recordedBlobUrl!} style={{ flex: 1 }} />
              <Tooltip title={t("formAction.delete")}>
                <IconButton
                  size="small"
                  onClick={() => setOpenFormDeleteRecording(true)}
                  sx={{
                    color: "#d32f2f",
                    marginLeft: 2,
                    borderRadius: "50%",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      border: "2px solid #d32f2f",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <IconDeleteRed />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        ) : !existingRecordingDeleted && recordingFiles.length > 0 ? (
          <div
            style={{
              marginTop: "12px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <audio
                controls
                src={recordingFiles[0].recordingUrl}
                style={{ flex: 1 }}
              />
              <Tooltip title={t("formAction.delete")}>
                <IconButton
                  size="small"
                  onClick={() => setOpenFormDeleteRecording(true)}
                  sx={{
                    color: "#d32f2f",
                    marginLeft: 2,
                    borderRadius: "50%",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      border: "2px solid #d32f2f",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <IconDeleteRed />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        ) : null}

        {(isRecording || isPaused) && (
          <div
            className="warning flex justify-content-start"
            style={{ marginBottom: 12 }}
          >
            <IconWarningFormEdit />
            <span style={{ marginLeft: 12, flex: 1 }} className="txt-black-1">
              {t("warningUpdateItem3")}
            </span>
          </div>
        )}

        <div className="update-media-upload-file mt-24 mb-24 w-100">
          <MediaUploadMachineReportHistory
            key={refreshKey}
            setFileCount={setFileCount}
            medias={mediaFiles}
            setHasUploadError={setHasUploadError}
            setMedias={(files: File[]) => {
              const existingFiles = mediaFiles.map(
                (file: any) =>
                  file.filePath || file.mediaUrl || file.thumbnailUrl,
              );
              const newFiles = files.map(
                (file: any) => file.filePath || file.mediaUrl,
              );
              const removedFiles = existingFiles.filter(
                (mediaUrl: string) => !newFiles.includes(mediaUrl),
              );
              if (removedFiles.length > 0) {
                setRemovedMediaUrls((prev) => [...prev, ...removedFiles]);
              }
              setMediaFiles(files);
              setFileCount(files.length);
            }}
            onPreviewMedia={(mediaUrls: string[]) => {
              handlePreviewMedia(mediaUrls);
            }}
            uploadDescription={uploadDescription1}
            maxFiles={5}
            fileUploadLimit={totalMediaCount}
            showMaxUploadLimit={true}
            typeFile={TYPE_FILE_UPLOAD.pdfImageVideo}
          />
        </div>

        <div
          className="warning flex justify-content-start"
          style={{ marginBottom: 12 }}
        >
          <IconWarningFormEdit />
          <span style={{ marginLeft: 12, flex: 1 }} className="txt-black-1">
            {t("formEdit.warningUpdateItem")}
          </span>
        </div>

        <div
          className="flex justify-content-end group-btn-footer"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            paddingTop: "16px",

            zIndex: 1000,
          }}
        >
          <Button
            className="btn btn-no-border"
            onClick={() => {
              setInspectionDialogOpen(false);
              setFileCount(0);
              setMediaFiles([]);
              setInspectionName("");
              setInspectionTime("");
              setInspectionComment("");
              setResultValue("");
              setSelectedInspection(null);
              setRemovedMediaUrls([]);

              if (isRecording || isPaused) {
                stopRecording();
              }

              setRecordedBlob(null);
              setRecordingTime(0);
              setIsPaused(false);
              setIsRecording(false);
              setRecorder(null);
              setRecordingInterval(null);
              setMediaAvailable(true);

              setRecordingFiles([]);
              setRecordingCount(0);
              setExistingRecordingDeleted(false);
            }}
            disabled={isRecording || isPaused || isUpdatingInspectionItem}
          >
            {t("dialogReport.cancel")}
          </Button>

          <Button
            className={`btn btn-primary ml-8`}
            onClick={handleUpdateInspectionItemClick}
            disabled={
              isUpdatingInspectionItem ||
              isRecording ||
              isPaused ||
              error ||
              (resultValue === "ANOMARY" &&
                ((!inspectionComment.trim() &&
                  mediaFiles.length === 0 &&
                  !recordedBlob &&
                  recordingFiles.length === 0) ||
                  (hasUploadError &&
                    mediaFiles.length === 0 &&
                    !inspectionComment.trim() &&
                    !recordedBlob &&
                    recordingFiles.length === 0))) ||
              ((resultValue === "NOT_APPLICABLE" || resultValue === "OK") &&
                inspectionComment !== "" &&
                !inspectionComment.trim())
            }
          >
            {t("formAction.update")}
          </Button>
        </div>
      </DataDialog>

      <DataDialog
        title={t("errNetwork.title")}
        open={openFormNoMic}
        setOpen={setOpenFormNoMic}
        disableBackdropClick={true}
      >
        <div className="form-confirm-delete">
          <p className="txt-gray-1 fs-16">{t("noMic")}</p>
          <div className="button-form-delete flex justify-content-end">
            <Button
              onClick={() => setOpenFormNoMic(false)}
              className="btn btn-primary ml-8"
            >
              {t("ok")}
            </Button>
          </div>
        </div>
      </DataDialog>

      <DataDialog
        title={t("deleteRecording")}
        open={openFormDeleteRecording}
        setOpen={setOpenFormDeleteRecording}
        disableBackdropClick={true}
      >
        <div className="form-confirm-delete">
          <p className="txt-gray-1 fs-16">{t("inspectionDelete.content")}</p>
          <div className="button-form-delete flex justify-content-end">
            <Button
              onClick={() => setOpenFormDeleteRecording(false)}
              className="btn btn-no-border"
              style={{ marginTop: "4px" }}
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button onClick={handleDeleteRecording} className="btn-delete">
              {t("formAction.delete")}
            </Button>
          </div>
        </div>
      </DataDialog>

      <DataDialog
        open={pdfConfirmOpen}
        disableBackdropClick={true}
        setOpen={() => setPdfConfirmOpen(false)}
        className="dialog-container"
      >
        <p className="fs-16" style={{ whiteSpace: "pre-line" }}>
          {t("pdfExpireWarning")}
        </p>

        <div
          className="flex justify-content-end group-btn-footer"
          style={{ gap: "12px" }}
        >
          <Button
            className="btn btn-no-border"
            onClick={() => {
              setPdfConfirmOpen(false);
              setPendingPDFType(null);
            }}
          >
            {t("dialogReport.cancel")}
          </Button>

          <Button
            className="btn btn-primary ml-8"
            onClick={() => {
              setPdfConfirmOpen(false);

              if (pendingPDFType === "INSPECTION") {
                setInspectionPDFdialogOpen(true);
              }
            }}
          >
            {t("ok")}
          </Button>
        </div>
      </DataDialog>

      <DataDialog
        open={InspectionPDFdialogOpen}
        setOpen={() => setInspectionPDFdialogOpen(false)}
        disableBackdropClick={true}
        title={
          <p
            style={{
              fontWeight: "bold",
              fontSize: "24px",
              marginBottom: "0px",
              marginTop: "0px",
              color: "black",
            }}
          >
            {t("PDFRemarks")}
          </p>
        }
        className="dialog-container"
      >
        <p className="txt-gray-1 fs-16">{t("pfdComments")}</p>
        <div className="wrapper-text-field mt-8">
          <TextField
            multiline
            rows={3}
            className="input-field"
            label={t("HeaderRemarks")}
            value={pdfHeaderRemarks}
            fullWidth
            inputProps={{ maxLength: 1000 }}
            onChange={handleInputPdfHeaderChange}
            error={pdfHeaderRemarksError}
            helperText={pdfHeaderRemarksError ? t("invalidCharacters") : ""}
            InputProps={{
              endAdornment: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  {pdfHeaderRemarksError && <IconInputError />}
                </div>
              ),
            }}
          />
          {pdfHeaderRemarksError && (
            <span className="error-text fs-12 ml-15 txt-red"></span>
          )}
        </div>

        <div className="wrapper-text-field mt-8">
          <TextField
            multiline
            rows={3}
            className="input-field"
            label={t("FooterRemarks")}
            value={pdfFooterRemarks}
            fullWidth
            inputProps={{ maxLength: 1000 }}
            onChange={handleInputPdfFooterChange}
            error={pdfFooterRemarksError}
            helperText={pdfFooterRemarksError ? t("invalidCharacters") : ""}
            InputProps={{
              endAdornment: (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  {pdfFooterRemarksError && <IconInputError />}
                </div>
              ),
            }}
          />
          {pdfFooterRemarksError && (
            <span className="error-text fs-12 ml-15 txt-red"></span>
          )}
        </div>

        <div
          className="flex justify-content-end group-btn-footer"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            paddingTop: "16px",

            zIndex: 1000,
          }}
        >
          <Button
            className="btn btn-no-border"
            onClick={() => {
              setInspectionPDFdialogOpen(false);
              setSelectedInspectionIdPDF(null);
              setPdfHeaderRemarks("");
              setPdfFooterRemarks("");
            }}
          >
            {t("dialogReport.cancel")}
          </Button>

          <Button
            className={`btn btn-primary ml-8`}
            onClick={() => {
              handleDownloadClick(selectedInspectionIdPDF ?? "");
            }}
            disabled={pdfHeaderRemarksError || pdfFooterRemarksError}
          >
            {t("pdfOutput")}
          </Button>
        </div>
      </DataDialog>

      {isLoading ? (
        <TableContainer
          className={`table-inspection-form ${
            isMobile() && iOSversion() < 15 ? "iOS-less-than-15" : ""
          }`}
          component={Paper}
          style={{
            maxHeight: TABLE_MAX_HEIGHT,
            borderRadius: isMobile() ? "0" : "8px",
          }}
        >
          <Table
            className="data-table"
            dir={isRTL ? "rtl" : "ltr"}
            sx={{ minWidth: TABLE_MIN_WIDTH, maxHeight: TABLE_MAX_HEIGHT }}
            stickyHeader
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    padding: "6.625px 12px",
                    position: "sticky",
                    top: "-1px",
                    ...stickyInspectionColumnEdge,
                    zIndex: 20,
                    ...stickyInspectionColumnCellSx,
                  }}
                  align={isRTL ? "right" : "left"}
                  style={{ ...stickyInspectionColumnSize }}
                  className={`${
                    isEditing ? "bg-editing-light" : "bg-purple"
                  } txt-black fs-16`}
                >
                  <Skeleton variant="text" width={100} height={24} />
                </TableCell>

                {Array.from({ length: getDaysInMonth(currentDate) }).map(
                  (_, i) => (
                    <TableCell
                      key={i}
                      align="center"
                      className={`${
                        isEditing ? "bg-editing-light" : "bg-purple"
                      } txt-black fs-16`}
                      style={{ minWidth: 108, maxWidth: 108 }}
                      sx={{ padding: "6.625px 12px" }}
                    >
                      <Skeleton
                        variant="text"
                        width={20}
                        height={24}
                        sx={{ mx: "auto" }}
                      />
                    </TableCell>
                  ),
                )}
              </TableRow>

              <TableRow>
                {Array.from({ length: getDaysInMonth(currentDate) }).map(
                  (_, i) => (
                    <TableCell
                      key={i}
                      align="center"
                      className={`${
                        isEditing ? "bg-editing-light" : "bg-purple"
                      } txt-black fs-16`}
                      style={{ minWidth: 108, maxWidth: 108 }}
                    />
                  ),
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell
                  align={isRTL ? "right" : "left"}
                  style={{
                    ...stickyInspectionColumnSize,
                    position: "sticky",
                    ...stickyInspectionColumnEdge,
                    zIndex: 1,
                  }}
                  className={`${
                    isEditing ? "bg-editing-light" : "bg-purple"
                  } txt-black fs-16`}
                />
                {Array.from({ length: getDaysInMonth(currentDate) }).map(
                  (_, i) => (
                    <TableCell
                      key={i}
                      style={{ minWidth: 108, maxWidth: 108 }}
                    />
                  ),
                )}
              </TableRow>

              {Array.from({ length: 6 }).map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell
                    align={isRTL ? "right" : "left"}
                    style={{
                      ...stickyInspectionColumnSize,
                      position: "sticky",
                      ...stickyInspectionColumnEdge,
                      zIndex: 1,
                    }}
                    sx={stickyInspectionColumnCellSx}
                    className={`${
                      isEditing ? "bg-editing-light" : "bg-purple"
                    } txt-black fs-16`}
                  >
                    <Skeleton variant="text" width={140} height={20} />
                  </TableCell>

                  {Array.from({ length: getDaysInMonth(currentDate) }).map(
                    (_, i) => (
                      <TableCell
                        key={i}
                        align="center"
                        style={{ minWidth: 108, maxWidth: 108 }}
                      >
                        {(rowIndex + i) % 6 === 0 ? (
                          <Skeleton
                            variant="circular"
                            width={30}
                            height={30}
                            sx={{ mx: "auto" }}
                          />
                        ) : null}
                      </TableCell>
                    ),
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableContainer
          className={`table-inspection-form ${
            isMobile() && iOSversion() < 15 ? "iOS-less-than-15" : ""
          }`}
          component={Paper}
          style={{
            maxHeight: TABLE_MAX_HEIGHT,
            borderRadius: isMobile() ? "0" : "8px",
          }}
          ref={tableContainerRef}
          onScroll={handleTableScroll}
        >
          <Table
            className="data-table"
            dir={isRTL ? "rtl" : "ltr"}
            sx={{ minWidth: TABLE_MIN_WIDTH, maxHeight: TABLE_MAX_HEIGHT }}
            stickyHeader
            size="small"
            aria-labelledby="tableTitle"
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    padding: "6.625px 12px",
                    ...stickyInspectionColumnCellSx,
                  }}
                  align={isRTL ? "right" : "left"}
                  rowSpan={2}
                  style={{
                    ...stickyInspectionColumnSize,
                    fontWeight: 700,
                    position: "sticky",
                    top: "-1px",
                    ...stickyInspectionColumnEdge,
                    zIndex: 20,
                    background: isEditing ? "#DA9309" : "#d6cfd8",
                  }}
                  className={`${
                    isEditing ? "bg-editing-light" : "bg-purple"
                  } fs-16 txt-black`}
                >
                  <Box sx={stickyInspectionColumnHeaderContentSx}>
                    {t("inspectionItem")}
                  </Box>
                </TableCell>

                {Array.from({ length: getDaysInMonth(currentDate) }).map(
                  (_day, i) => {
                    const columnDate = format(
                      new Date(
                        getYear(currentDate),
                        getMonth(currentDate),
                        i + 1,
                      ),
                      DATE_TIME_FORMAT_1,
                    );

                    const matchingInspections =
                      displayData?.[0]?.[columnDate]?.map(
                        (record: any) => record.inspectionId,
                      ) || [];

                    return (
                      <TableCell
                        className={`${
                          isEditing ? "bg-editing-light" : "bg-purple"
                        } txt-black-1 fw-700 fs-16`}
                        sx={{
                          padding: "6.625px 12px 6.625px",
                        }}
                        style={{
                          minWidth: 108,
                          maxWidth: 108,
                          position: "sticky",
                        }}
                        align="center"
                        key={i}
                        colSpan={
                          (displayData?.[0]?.[columnDate] as Array<any>)
                            ?.length || 1
                        }
                        onClick={() => {
                          if (onHeaderCellClick) {
                            onHeaderCellClick(matchingInspections);
                          }
                        }}
                      >
                        {i + 1}
                      </TableCell>
                    );
                  },
                )}
              </TableRow>

              <TableRow>
                {Array.from({ length: getDaysInMonth(currentDate) }).map(
                  (_day, i) => {
                    const columnDate = format(
                      new Date(
                        getYear(currentDate),
                        getMonth(currentDate),
                        i + 1,
                      ),
                      DATE_TIME_FORMAT_1,
                    );

                    const records =
                      (displayData?.[0]?.[columnDate] as Array<any>) || [];

                    return records.length > 0 ? (
                      records.map((record: any, idx: number) => (
                        <TableCell
                          style={{
                            minWidth: 108,
                            maxWidth: 108,
                            cursor: isEditing ? "pointer" : "default",
                          }}
                          align="center"
                          key={`${i}-${idx}`}
                          className={`${
                            isEditing ? "bg-editing-light" : "bg-purple"
                          } txt-black fs-16`}
                          // onClick={async () => {
                          //   if (isEditing) {
                          //     if (
                          //       record?.inspectionId &&
                          //       groupId &&
                          //       machineId
                          //     ) {
                          //       try {
                          //         handleOpenPopup(
                          //           record.inspectionId,
                          //           groupId,
                          //           machineId,
                          //         );
                          //       } catch (error) {
                          //         console.error(
                          //           "Failed to fetch inspection id",
                          //           error,
                          //         );
                          //       }
                          //     } else {
                          //       console.error(
                          //         "Missing required parameters: groupId or machineId",
                          //       );
                          //     }
                          //   }
                          // }}
                        >
                          <p className="m-0 txt-gray-3 fw-500 fs-12">
                            {formatTime(record?.inspectionAt, "a")}
                          </p>
                          <p className="m-0 txt-gray-3 fw-500 fs-12">
                            {convertHour(record?.inspectionAt)}
                          </p>
                        </TableCell>
                      ))
                    ) : (
                      <TableCell
                        className={`${
                          isEditing ? "bg-editing-light" : "bg-purple"
                        } txt-black fs-16`}
                        key={i}
                        align="center"
                        style={{
                          minWidth: 108,
                          maxWidth: 108,
                          cursor: "default",
                        }}
                      />
                    );
                  },
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {!isEditing && (
                <TableRow>
                  <TableCell
                    align={isRTL ? "right" : "left"}
                    style={{
                      ...stickyInspectionColumnSize,
                      fontWeight: 700,
                      position: "sticky",
                      ...stickyInspectionColumnEdge,
                      zIndex: 1,
                    }}
                    sx={stickyInspectionColumnCellSx}
                    className={`${
                      isEditing ? "bg-editing-light" : "bg-purple"
                    } txt-black-1 fs-16`}
                  ></TableCell>

                  {Array.from({ length: getDaysInMonth(currentDate) })?.map(
                    (_day, i) => {
                      const records = displayData?.[0]?.[
                        format(
                          new Date(
                            getYear(currentDate),
                            getMonth(currentDate),
                            i + 1,
                          ),
                          DATE_TIME_FORMAT_1,
                        )
                      ] as any;

                      return records?.length ? (
                        records.map((record: any, idx: number) => {
                          return (
                            <TableCell
                              style={{ minWidth: 108, maxWidth: 108 }}
                              align="center"
                              key={idx}
                            >
                              <span
                                className="flex-centered pointer"
                                onClick={() => {
                                  setSelectedInspectionIdPDF(
                                    record.inspectionId,
                                  );

                                  setPendingPDFType("INSPECTION");
                                  setPdfConfirmOpen(true);
                                }}
                              >
                                <PictureAsPdfOutlined
                                  className="icon-pdf"
                                  style={{
                                    fontSize: "24px",
                                    color: "darkblue",
                                  }}
                                />
                              </span>
                              <span>
                                {record.time
                                  ? format(new Date(record.time), "HH:mm")
                                  : t("")}
                              </span>
                            </TableCell>
                          );
                        })
                      ) : (
                        <TableCell
                          style={{ minWidth: 108, maxWidth: 108 }}
                          key={i}
                          align="center"
                        />
                      );
                    },
                  )}
                </TableRow>
              )}

              {isEditing && (
                <TableRow>
                  <TableCell
                    align={isRTL ? "right" : "left"}
                    style={{
                      ...stickyInspectionColumnSize,
                      fontWeight: 700,
                      position: "sticky",
                      ...stickyInspectionColumnEdge,
                      zIndex: 1,
                    }}
                    sx={stickyInspectionColumnCellSx}
                    className="bg-editing-light txt-black-1 fs-16"
                  >
                    {t("formAction.edit")}
                  </TableCell>

                  {Array.from({ length: getDaysInMonth(currentDate) })?.map(
                    (_day, i) => {
                      const records = displayData?.[0]?.[
                        format(
                          new Date(
                            getYear(currentDate),
                            getMonth(currentDate),
                            i + 1,
                          ),
                          DATE_TIME_FORMAT_1,
                        )
                      ] as any;

                      return records?.length ? (
                        records.map((record: any, idx: number) => (
                          <TableCell
                            style={{
                              minWidth: 108,
                              maxWidth: 108,
                              cursor: canEditOrDeleteInspection(record)
                                ? "pointer"
                                : "default",
                            }}
                            align="center"
                            key={`edit-${i}-${idx}`}
                            className="bg-editing-light"
                            onClick={() => {
                              if (!canEditOrDeleteInspection(record)) return;
                              if (record?.inspectionId) {
                                onEditInspection?.(record.inspectionId);
                              }
                            }}
                          >
                            {canEditOrDeleteInspection(record) ? (
                              <span className="flex-centered pointer">
                                <IconEditSquare
                                  strokeColor="#1b232a"
                                  size={22}
                                />
                              </span>
                            ) : null}
                          </TableCell>
                        ))
                      ) : (
                        <TableCell
                          style={{ minWidth: 108, maxWidth: 108 }}
                          key={`edit-empty-${i}`}
                          align="center"
                          className="bg-editing-light"
                        />
                      );
                    },
                  )}
                </TableRow>
              )}

              {displayData?.map((row: any, index: number) => {
                if (
                  isEditing &&
                  row?.inspectionItemName === ItemInspectionEnum.LOCATION
                ) {
                  return null;
                }

                const isInactiveItem = row?.name?.includes("Inactive");
                const inspectionItemDisplayName = isInactiveItem
                  ? String(row?.name ?? "").replace(" (Inactive)", "")
                  : (row?.name ?? "");
                const inspectionItemDescription = row?.description ?? "";

                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <TableCell
                      align={isRTL ? "right" : "left"}
                      style={{
                        ...stickyInspectionColumnSize,
                        fontWeight: 400,
                        position: "sticky",
                        ...stickyInspectionColumnEdge,
                        zIndex: 1,
                      }}
                      sx={stickyInspectionColumnCellSx}
                      className={`${
                        isEditing ? "bg-editing-light" : "bg-purple"
                      } txt-black-1 fs-16`}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          minWidth: 0,
                          maxWidth: "100%",
                          flexDirection: isRTL ? "row-reverse" : "row",
                          justifyContent: isRTL ? "flex-end" : "flex-start",
                          columnGap: "10px",
                        }}
                      >
                        {isInactiveItem ? (
                          <Box
                            component="span"
                            sx={{
                              flexShrink: 0,
                              marginTop: "2px",
                              display: "inline-flex",
                            }}
                          >
                            <IconDeleteGray />
                          </Box>
                        ) : null}
                        <Box
                          sx={{
                            minWidth: 0,
                            flex: "1 1 0%",
                            overflow: "hidden",
                            textAlign: stickyInspectionColumnTextAlign,
                          }}
                        >
                          <DataTooltip
                            width="100%"
                            alwaysShow
                            isTextPre
                            tooltipContent={
                              <>
                                <b>{inspectionItemDisplayName}</b>
                                {inspectionItemDescription && (
                                  <>
                                    {"\n"}
                                    {inspectionItemDescription}
                                  </>
                                )}
                              </>
                            }
                          >
                            {inspectionItemDisplayName}
                          </DataTooltip>
                        </Box>
                      </Box>
                    </TableCell>

                    {Array.from({ length: getDaysInMonth(currentDate) })?.map(
                      (_day, i) => {
                        let records = row?.[
                          format(
                            new Date(
                              getYear(currentDate),
                              getMonth(currentDate),
                              i + 1,
                            ),
                            DATE_TIME_FORMAT_1,
                          )
                        ] as any;
                        return !!records?.length ? (
                          records?.map((record: any, i: number) => {
                            let item = record?.inspectionResults?.find(
                              (ele: any) =>
                                ele?.customInspectionItemId ===
                                row?.customInspectionItemId,
                            );

                            let itemShow;

                            if (item) {
                              if (!!item?.itemCode) {
                                itemShow = !!item.result && (
                                  <span className="txt-right w-100">
                                    {formatNumberWithCommas(item.result)}
                                  </span>
                                );
                              } else if (item.result === ItemResultType.OK) {
                                itemShow = !!item?.machineReport
                                  ?.machineReportId ? (
                                  <span
                                    className={`flex-centered ${
                                      isEditing ? "" : "pointer"
                                    }`}
                                    onClick={
                                      !isEditing
                                        ? () =>
                                            handleClickIconReport(
                                              item?.machineReport
                                                ?.machineReportId,
                                            )
                                        : undefined
                                    }
                                    style={getCircleStyle(true)}
                                  >
                                    <IconTick fillColor="#0C7040" />
                                  </span>
                                ) : (
                                  <span style={getCircleStyle(false)}>
                                    <IconTick fillColor="#0C7040" />
                                  </span>
                                );
                              } else if (item.result === ItemResultType.NONE) {
                                itemShow = !!item?.machineReport
                                  ?.machineReportId ? (
                                  <span
                                    className={`flex-centered ${
                                      isEditing ? "" : "pointer"
                                    }`}
                                    onClick={
                                      !isEditing
                                        ? () =>
                                            handleClickIconReport(
                                              item?.machineReport
                                                ?.machineReportId,
                                            )
                                        : undefined
                                    }
                                    style={getCircleStyleNone(true)}
                                  ></span>
                                ) : (
                                  <span style={getCircleStyleNone(false)}>
                                    <IconMessageNew width={24} height={24} />
                                  </span>
                                );
                              } else if (
                                item.result === ItemResultType.FREE_TEXT
                              ) {
                                const hasMachineReport =
                                  !!item?.machineReport?.machineReportId;
                                const hasFreeText = !!item?.freeText?.trim?.();

                                itemShow =
                                  hasMachineReport || hasFreeText ? (
                                    <span
                                      className={`flex-centered ${
                                        !isEditing && hasMachineReport
                                          ? "pointer"
                                          : ""
                                      }`}
                                      onClick={
                                        !isEditing && hasMachineReport
                                          ? () =>
                                              handleClickIconReport(
                                                item?.machineReport
                                                  ?.machineReportId,
                                              )
                                          : undefined
                                      }
                                      style={getCircleStyleNone(true)}
                                    ></span>
                                  ) : (
                                    <span style={getCircleStyleNone(false)}>
                                      <IconMessageNew width={24} height={24} />
                                    </span>
                                  );
                              } else if (
                                item.result === ItemResultType.NOT_APPLICABLE
                              ) {
                                itemShow = !!item?.machineReport
                                  ?.machineReportId ? (
                                  <span
                                    className={`flex-centered ${
                                      isEditing ? "" : "pointer"
                                    }`}
                                    onClick={
                                      !isEditing
                                        ? () =>
                                            handleClickIconReport(
                                              item?.machineReport
                                                ?.machineReportId,
                                            )
                                        : undefined
                                    }
                                    style={getCircleStyleNotApplicabale(true)}
                                  >
                                    <IconNotApplicable />
                                  </span>
                                ) : (
                                  <span
                                    style={getCircleStyleNotApplicabale(false)}
                                  >
                                    <IconNotApplicable />
                                  </span>
                                );
                              } else {
                                itemShow = (
                                  <span
                                    className={`flex-centered ${
                                      isEditing ? "" : "pointer"
                                    }`}
                                    onClick={
                                      !isEditing
                                        ? () => {
                                            getMachineReportId(
                                              item?.machineReport
                                                ?.machineReportId,
                                            );
                                          }
                                        : undefined
                                    }
                                  >
                                    <IconReportCircle />
                                  </span>
                                );
                              }
                            } else {
                              switch (row?.inspectionItemName) {
                                case ItemInspectionEnum.STAFF_NAME:
                                  const fullName =
                                    localeCode === "ja"
                                      ? `${record?.surname} ${record?.givenName}`
                                      : `${record?.givenName} ${record?.surname}`;

                                  itemShow = (
                                    <DataTooltip isTextPre width={"90px"}>
                                      {fullName}
                                    </DataTooltip>
                                  );
                                  break;
                                case ItemInspectionEnum.LOCATION:
                                  itemShow =
                                    record?.lat && record?.lng ? (
                                      <span
                                        onClick={() => {
                                          if (!isEditing) {
                                            setDataCell(record);
                                            setOpen(true);
                                          }
                                        }}
                                        className={`flex-centered ${
                                          isEditing ? "" : "pointer"
                                        }`}
                                      >
                                        <IconLocationMachine />
                                      </span>
                                    ) : undefined;
                                  break;
                              }
                            }
                            function getCircleStyleNone(
                              hasBorder = true,
                            ): React.CSSProperties {
                              return {
                                border: hasBorder
                                  ? "2px solid #d3d3d3"
                                  : "none",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "30px",
                                height: "30px",
                              };
                            }

                            function getCircleStyle(
                              hasBorder = true,
                            ): React.CSSProperties {
                              return {
                                border: hasBorder
                                  ? "2px solid #d3d3d3"
                                  : "none",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "30px",
                                height: "30px",
                              };
                            }

                            function getCircleStyleNotApplicabale(
                              hasBorder = true,
                              stroke = "#D5D5D5",
                            ): React.CSSProperties {
                              return {
                                backgroundColor: "transparent",
                                border: hasBorder
                                  ? `2px solid ${stroke}`
                                  : "none",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "30px",
                                height: "30px",
                              };
                            }

                            const isStaffNameRow =
                              row?.inspectionItemName ===
                              ItemInspectionEnum.STAFF_NAME;
                            return (
                              <TableCell
                                style={{
                                  minWidth: 108,
                                  maxWidth: 108,
                                  cursor:
                                    isEditing && !isStaffNameRow
                                      ? "pointer"
                                      : "default",
                                }}
                                key={i}
                                align="center"
                                onClick={() => {
                                  if (!isEditing) {
                                  }

                                  // if (isEditing) {
                                  //   const field = row?.name;

                                  //   const itemCode = fieldMapping[field];

                                  //   if (itemCode) {
                                  //     const result =
                                  //       record?.inspectionResults?.find(
                                  //         (r: { itemCode: string }) =>
                                  //           r.itemCode === itemCode,
                                  //       );

                                  //     if (result) {
                                  //       handleCellClick(
                                  //         record.inspectionId,
                                  //         field,
                                  //         result.result,
                                  //         result.inspectionItemId ||
                                  //           row?.customInspectionItemId,
                                  //         result.inspectionResultId,
                                  //       );
                                  //     }
                                  //   } else {
                                  //     InspectionItemDialogOpen(
                                  //       record,
                                  //       row,
                                  //       isEditing,
                                  //       groupId,
                                  //       machineId,
                                  //     );
                                  //   }
                                  // }
                                }}
                              >
                                {fieldMapping[row?.name] === "ODOMETER" &&
                                record?.odometerValue
                                  ? formatNumberWithCommas(
                                      record?.odometerValue,
                                    )
                                  : fieldMapping[row?.name] ===
                                        "SERVICE_METER" &&
                                      record?.serviceMeterValue
                                    ? formatNumberWithCommas(
                                        record?.serviceMeterValue,
                                      )
                                    : ""}

                                {!!itemShow && (
                                  <span className="flex-centered fs-16 txt-black-1 lh-24">
                                    {itemShow}
                                  </span>
                                )}
                              </TableCell>
                            );
                          })
                        ) : (
                          <TableCell
                            style={{ minWidth: 108, maxWidth: 108 }}
                            key={i}
                            align="center"
                          />
                        );
                      },
                    )}
                  </TableRow>
                );
              })}

              {showDeleteRow && (
                <TableRow>
                  <TableCell
                    align={isRTL ? "right" : "left"}
                    style={{
                      ...stickyInspectionColumnSize,
                      fontWeight: 700,
                      position: "sticky",
                      ...stickyInspectionColumnEdge,
                      zIndex: 1,
                    }}
                    sx={stickyInspectionColumnCellSx}
                    className="bg-editing-light txt-black-1 fs-16"
                  >
                    <Box sx={stickyInspectionColumnHeaderContentSx}>
                      {t("deleteInspection")}
                    </Box>
                  </TableCell>

                  {Array.from({ length: getDaysInMonth(currentDate) })?.map(
                    (_day, i) => {
                      const records = displayData?.[0]?.[
                        format(
                          new Date(
                            getYear(currentDate),
                            getMonth(currentDate),
                            i + 1,
                          ),
                          DATE_TIME_FORMAT_1,
                        )
                      ] as any;

                      return !!records?.length ? (
                        records?.map((record: any, idx: number) => (
                          <TableCell
                            key={`${i}-${idx}`}
                            align="center"
                            style={{
                              minWidth: 108,
                              maxWidth: 108,
                              cursor: canEditOrDeleteInspection(record)
                                ? "pointer"
                                : "default",
                            }}
                            className="bg-editing-light"
                            onClick={() => {
                              if (!canEditOrDeleteInspection(record)) return;
                              handleDeleteClick(record.inspectionId);
                            }}
                          >
                            {canEditOrDeleteInspection(record) ? (
                              <span className="flex-centered pointer">
                                <IconDeleteRow />
                              </span>
                            ) : null}
                          </TableCell>
                        ))
                      ) : (
                        <TableCell
                          style={{ minWidth: 108, maxWidth: 108 }}
                          key={i}
                          align="center"
                          className="bg-editing-light"
                        />
                      );
                    },
                  )}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* <DataDialog
        open={isPopupOpen}
        title={t("updateinspectiondatetime")}
        onClose={(event: any, reason: string) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          handleClosePopup();
        }}
      >
        <DialogContent>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              alignItems: "center",
              marginTop: "0rem",
            }}
          >
            <div>
              <DatePickerInput
                label={t("report.labelStartDate")}
                value={valueStartDate}
                onChange={(newValue) => handleChangeStartDate(newValue)}
                onAccept={(newValue) => handleChangeStartDate(newValue)}
              />
            </div>

            <div style={{ flex: 1, marginTop: "-7px" }}>
              <TextField
                label={t("time")}
                type="time"
                value={selectedTime}
                onChange={(e) => setSelectedTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                margin="normal"
                style={{ width: "100%" }}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              marginTop: "1`rem",
            }}
          >
            <strong>{t("")}</strong>
          </div>
        </DialogContent>

        <DialogActions
          style={{ marginTop: "0px", marginRight: "0px", marginBottom: "0px" }}
        >
          <Button className="btn btn-no-border" onClick={handleClosePopup}>
            {t("dialogReport.cancel")}
          </Button>
          <Button
            className={`btn btn-primary ml-8`}
            onClick={updateInspectionAt}
            disabled={!valueStartDate || !selectedTime}
          >
            {t("formAction.update")}
          </Button>
        </DialogActions>
      </DataDialog> */}

      <DataDialog
        open={!!dialogData}
        title={
          dialogData?.field
            ? `${t("formAction.update")} ${dialogData.field}`
            : ""
        }
        setOpen={() => setDialogData(null)}
        disableBackdropClick={true}
      >
        <div style={{ padding: "0px", marginBottom: "10px" }}>
          <TextField
            label={`${t("enter")} ${dialogData?.field} *`}
            className={`input-field ${
              !dialogData?.value ? "error-border" : ""
            }`}
            value={dialogData?.value || ""}
            onChange={(e) => {
              const input = e.target.value;

              const validatedInput = input.match(/^\d*\.?\d{0,1}$/)
                ? input
                : dialogData?.value || "";

              setDialogData((prev) =>
                prev ? { ...prev, value: validatedInput } : prev,
              );
            }}
            onBlur={() => {
              if (dialogData?.value) {
                const value = dialogData.value;

                if (/^\d+$/.test(value)) {
                  setDialogData((prev) =>
                    prev ? { ...prev, value: `${value}.0` } : prev,
                  );
                } else if (value.endsWith(".")) {
                  setDialogData((prev) =>
                    prev ? { ...prev, value: `${value}0` } : prev,
                  );
                }
              }
            }}
            fullWidth
            inputProps={{
              step: "0.1",
              min: "0",
            }}
            error={!dialogData?.value}
            helperText={!dialogData?.value ? t("required") : null}
            FormHelperTextProps={{
              className: "error-text",
            }}
          />
          <div
            style={{
              marginTop: "10px",
              marginBottom: "-10px",
              marginRight: "-3px",
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <Button
              className="btn btn-no-border"
              onClick={() => setDialogData(null)}
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button
              className={`btn btn-primary ml-8`}
              onClick={handleUpdateInspection}
              disabled={!dialogData?.value}
            >
              {t("formAction.update")}
            </Button>
          </div>
        </div>
      </DataDialog>

      <DataDialog
        title={t("inspectionDelete.title")}
        open={openFormDelete}
        setOpen={setOpenFormDelete}
        disableBackdropClick={true}
      >
        <div className="form-confirm-delete">
          <p className="txt-gray-1 fs-16">{t("inspectionDelete.content")}</p>
          <div className="button-form-delete flex justify-content-end">
            <Button
              onClick={() => setOpenFormDelete(false)}
              className="btn btn-no-border"
              style={{ marginTop: "4px" }}
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button onClick={confirmDelete} className="btn-delete">
              {t("formAction.delete")}
            </Button>
          </div>
        </div>
      </DataDialog>

      {dataCell && (
        <DataDialog
          title={t("tableMachineDetail.location")}
          open={open}
          setOpen={setOpen}
          className="dialog-location-report"
          disableBackdropClick={true}
        >
          <iframe
            title="map-location"
            className="map-iframe"
            loading="lazy"
            src={`https://maps.google.com/maps?&q="+${dataCell?.lat}, ${dataCell?.lng}"&output=embed`}
          />
          <span className="fs-14 txt-gray-1 label-dialog">
            {t("tableMachineDetail.date")}
          </span>
          <p className="fs-16 txt-gray mt-4">
            {dataCell?.inspectionAt &&
              formatTime(new Date(dataCell?.inspectionAt), userTimeFormat)}
          </p>
          <span className="fs-14 txt-gray-1 label-dialog">
            {t("tableMachineDetail.reporter")}
          </span>
          <div className="flex-centered justify-content-start mt-8">
            {dataCell?.userPictureUrl ? (
              dataCell?.userPictureUrl === INVALID_URL ? (
                <Box
                  sx={{
                    width: 24,
                    height: 24,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconInvalidUrl />
                </Box>
              ) : (
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                  }}
                  alt="avatar-reporter"
                  src={dataCell?.userPictureUrl}
                  imgProps={{
                    onError: () => {
                      setDataCell({ ...dataCell, userPictureUrl: INVALID_URL });
                    },
                  }}
                />
              )
            ) : (
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconUser />
              </Box>
            )}

            <span className="fs-16 txt-gray ml-5 word-break txt-pre-wrap">
              {localeCode === "ja"
                ? `${dataCell?.surname} ${dataCell?.givenName}`
                : `${dataCell?.givenName} ${dataCell?.surname}`}
            </span>
          </div>
          <div className="flex justify-content-end">
            <Button
              onClick={() => setOpen(false)}
              className="btn btn-no-border"
            >
              {t("dialogRefuel.close")}
            </Button>
          </div>
        </DataDialog>
      )}

      <MachineReportDetailDialog
        open={openDialogReport}
        onClose={() => {
          setOpenDialogReport(false);
          setDbMachine("");
        }}
        dbMachine={dbMachine}
        setDbMachine={setDbMachine}
        userTimeFormat={userTimeFormat}
        localeCode={localeCode}
      />

      {isDialogOpen && machineReportId && groupId && machineId && (
        <AllReportsDataDialog
          key={dialogKey}
          id={groupId}
          machineId={machineId}
          machineReportId={machineReportId}
          reportType={INCIDENT_REPORTS}
          onClose={handleCloseDialog}
        />
      )}

      <SignatureDialog
        open={signatureDialogOpen}
        onClose={() => {
          if (!isUpdatingInspectionItem) {
            setSignatureDialogOpen(false);
          }
        }}
        onSend={handleSignatureUpdateSend}
        sendLabelKey="formAction.update"
        isSubmitting={isUpdatingInspectionItem}
      />
    </>
  );
}
